const baseConfig = require('@ringcentral-integration/babel-settings');

module.exports = baseConfig;
